/**
 * The show and hide toggle inside the password field.
 */

/**
 * Flip state.passwordShown. The template binds the field type and the
 * toggle's aria-pressed to it.
 *
 * The toggle cancels mousedown, so a pointer press leaves focus where it was.
 * If the field had focus, it keeps its caret and selection across the type
 * swap. Otherwise focus stays put: a tap must not open the soft keyboard.
 *
 * @param {Object} state - the wizard
 * @param {HTMLInputElement} input - the password field
 * @param {Function} afterRender - runs a callback after the type swap ($nextTick)
 */
export function togglePasswordReveal(state, input, afterRender) {
    const hadFocus = input.ownerDocument.activeElement === input;
    const start = input.selectionStart;
    const end = input.selectionEnd;

    state.passwordShown = !state.passwordShown;

    afterRender(() => {
        if (!hadFocus) {
            return;
        }

        input.focus();
        if (start !== null && end !== null) {
            input.setSelectionRange(start, end);
        }
    });
}
